import React from 'react';
import './footer.css';
import { FaGithub, FaLinkedin } from 'react-icons/fa6';
import portfolioConfig from '../../config/portfolioConfig';

const footerLinks = [
  { href: '#home', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#portfolio', label: 'Work' },
  { href: '#terminal', label: 'Console' },
  { href: '#contact', label: 'Contact' }
];

const Footer = () => {
  const { personal, social } = portfolioConfig;

  return (
    <footer className="site-footer">
      <div className="container site-footer__container">
        <div>
          <p className="section-eyebrow">Abhinav Dhawan</p>
          <p className="site-footer__copy">
            Full stack work with cleaner structure, better project context, and lighter-handed
            effects.
          </p>
        </div>

        <div className="site-footer__links">
          {footerLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </div>

        <div className="site-footer__socials">
          <a href={social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href={social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container">
          <small>© {new Date().getFullYear()} {personal.name}. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
